import { formatInTimeZone } from 'date-fns-tz';

export const DEFAULT_TIMEZONE = 'Europe/Madrid';

/**
 * Returns an ISO-8601 string with the appropriate offset for the configured timezone.
 */
export function formatDateWithTimezone(date: Date = new Date(), timezone: string = DEFAULT_TIMEZONE): string {
  return formatInTimeZone(date, timezone, "yyyy-MM-dd'T'HH:mm:ssXXX");
}

/**
 * Convenience helper that provides the current timestamp in the default timezone.
 */
export function nowWithTimezone(): string {
  return formatDateWithTimezone();
}
